import React, { Component } from "react";
import Card from "../../components/Card/Card.jsx";
import '../../assets/css/streams-page.css';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Chart from 'react-apexcharts';
import * as actions from '../../actions/streamListActions';
import {
  bandwithZoomableOptions,
  latencyZoomableOptions,
  latencyZoomableSendingOptions
} from "../../variables/Variables.jsx";

import {Grid,
  Row,
  Col,
  Panel,
  Form,
  Label,
  FormGroup,
  ControlLabel,
  Modal
} from "react-bootstrap";

import HorizontalFormInputs  from "../../components/FormInputs/HorizontalFormInputs.jsx";
import { HorizontalFormDoubleInputs } from "../../components/FormInputs/HorizontalFormDoubleInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";

class StreamDetails extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      input: {status: "disconnected"},
      output: {status: "disconnected"},
      inputStats: {
        bandwith: [],
        latency: []
      },
      outputStats: {
        bandwith: [],
        latency: []
      },
      showInputStats: false,
      showOutputStats: false
    }
    this.graphObjs = {};

    this.showStatsPopup = this.showStatsPopup.bind(this);
    this.getGraphDataInput = this.getGraphDataInput.bind(this);
    this.getGraphDataOutput = this.getGraphDataOutput.bind(this);
  }

  componentDidMount(){
    const {subscribeToStats, requestConnectionStatus} = this.props.actions;
    subscribeToStats(undefined, window.location.origin);
    requestConnectionStatus({});
    setInterval(() => requestConnectionStatus({}),10*1000);

    // const {startSrtStatStream} = this.props.actions;
    // startSrtStatStream({interval: 1000});
  }

  showStatsPopup = (e, statsDirection) => {
    const {getStreamStats} = this.props.actions;
    getStreamStats(this.props.selectedContainerId, statsDirection, this.getGraphDataInput, this.getGraphDataOutput, window.location.origin);
    if(statsDirection == 'input') {
      this.setState({
        showInputStats: true,
        showOutputStats: false
      });
    } else {
      this.setState({
        showInputStats: false,
        showOutputStats: true
      });
    }
  };

  hideStatsPopup = () => {
    this.setState({
      showInputStats: false,
      showOutputStats: false
    });
  };

  getGraphDataInput(jsonData) {
    let bandwithRecv = [];
    let bandwithLost = [];
    let bandwithDropped = [];
    let bandwithInflight = [];
    let latency = [];
    let latencyBuffer = [];
    jsonData.forEach(item => {
      let timestamp = Number(item.TimeStamp) / 1000;
      bandwithRecv.push([timestamp, item.pktRecv]);
      bandwithLost.push([timestamp, item.pktRcvLoss]);
      bandwithDropped.push([timestamp, item.pktRcvDrop]);
      bandwithInflight.push([timestamp, item.pktFlightSize]);
      latency.push([timestamp, item.RCVLATENCYms]);
      latencyBuffer.push([timestamp, item.msRcvBuf]);
    });
    let data = {
      bandwith: [{
        name: "Received",
        data: bandwithRecv
      },{
        name: "Lost",
        data: bandwithLost
      },{
        name: "Dropped",
        data: bandwithDropped
      },{
        name: "Inflight",
        data: bandwithInflight
      }],
      latency: [{
        name: "Latency",
        data: latency
      },{
        name: "Buffer",
        data: latencyBuffer
      }]
    };
    this.graphObjs && this.graphObjs.bandwidthin && this.graphObjs.bandwidthin.chart.updateSeries(data.bandwith);
    this.graphObjs && this.graphObjs.latencyin && this.graphObjs.latencyin.chart.updateSeries(data.latency);
    return {
      bandwith: [],
      latency: []
    };
  }

  getGraphDataOutput(jsonData) {
    let bandwithSent = [];
    let bandwithLost = [];
    let bandwithDropped = [];
    let bandwithInflight = [];
    let latencySendRate = [];
    let latencyBandwidth = [];
    jsonData.forEach(item => {
      let timestamp = Number(item.TimeStamp) / 1000;
      bandwithSent.push([timestamp, item.pktSent]);
      bandwithLost.push([timestamp, item.pktSndLoss]);
      bandwithDropped.push([timestamp, item.pktSndDrop]);
      bandwithInflight.push([timestamp, item.pktFlightSize]);
      latencySendRate.push([timestamp, item.mbpsSendRate]);
      latencyBandwidth.push([timestamp, item.mbpsBandwidth]);
    });
    let data = {
      bandwith: [{
        name: "Sent",
        data: bandwithSent
      },{
        name: "Lost",
        data: bandwithLost
      },{
        name: "Dropped",
        data: bandwithDropped
      },{
        name: "Inflight",
        data: bandwithInflight
      }],
      latency: [{
        name: "Sending Rate",
        data: latencySendRate
      },{
        name: "Bandwidth",
        data: latencyBandwidth
      }]
    };
    this.graphObjs && this.graphObjs.bandwidthout && this.graphObjs.bandwidthout.chart.updateSeries(data.bandwith);
    this.graphObjs && this.graphObjs.latencyout && this.graphObjs.latencyout.chart.updateSeries(data.latency);
    return {
      bandwith: [],
      latency: []
    };
  }

  convertToTime(timestamp) {
    var milliseconds = parseInt((timestamp % 1000) / 100),
    seconds = parseInt((timestamp / 1000) % 60),
    minutes = parseInt((timestamp / (1000 * 60)) % 60),
    hours = parseInt((timestamp / (1000 * 60 * 60)) % 24),
    days = parseInt((timestamp / (1000 * 60 * 60 * 24)));

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    return days + ":" + hours + ":" + minutes + ":" + seconds;
  }

  render() {

    // var sid = this.props.stats? this.props.stats.sid : "stats undefined";
    // var packets = this.props.recv ? this.props.recv.packets : 'nostats!';
    // console.log(`sid: ${sid}`);
    // console.log(`packets:`);
    // console.log(`${packets}`);

    return (
      <div className="content">
        <Grid fluid>

          <Panel bsStyle="primary">
            <Panel.Heading>
              <Panel.Title componentClass="h3">Stream Details</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <Row>
                <Col
                  md={4}
                  style={{ paddingLeft: 3 + "px", paddingRight: 3 + "px" }}
                >
                  <Card
                    title="Link Details"
                    content={
                      <Form horizontal style={{paddingTop:10 + "px"}}>
                        <Col md={4}>
                          <Label bsStyle="primary" style={{display: "inline-block", width: 50 + "%"}}></Label>
                        </Col>
                        <Col md={4}>
                          <Label bsStyle="primary direction-label">Receiving</Label>
                        </Col>
                        <Col md={4}>
                          <Label bsStyle="primary direction-label">Sending</Label>
                        </Col>
                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          status={this.props.input.status}
                          status2={this.props.output.status}
                          label="Status"
                          type="text"
                          bsClass="form-control"
                          placeholder="Status"
                          placeholder2="Status"
                          disabled="true"
                        />
                        <div>
                          <div className="col-md-12">
                            <FormGroup style={{ marginBottom: -10 + "px" }}>
                              <Col componentClass={ControlLabel} style={{ marginTop: 5 + "px" }} md={4}>
                                Peer IP
                              </Col>
                              <Col md={4}>
                                <a class="form-control form-control-bg clickable-field" target="_blank" href={'http://' + this.props.input.peerIP}>{this.props.input.peerIP}</a>
                              </Col>
                              <Col md={4}>
                                <a class="form-control form-control-bg clickable-field" target="_blank" href={'http://' + this.props.output.peerIP}>{this.props.output.peerIP}</a>
                              </Col>
                            </FormGroup>
                          </div>
                        </div>
                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.convertToTime(this.props.input.upTime)}
                          value2={this.convertToTime(this.props.output.upTime)}
                          label="Up Time"
                          type="text"
                          bsClass="form-control"
                          placeholder="Up time"
                          placeholder2="Up time"
                          disabled="true"
                        />
                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.props.input.link.bandwidth + " Mbs"}
                          value2={this.props.output.link.bandwidth + " Mbs"}
                          label="Bandwidth"
                          type="text"
                          bsClass="form-control"
                          placeholder="Bandwidth"
                          placeholder2="Bandwidth"
                          disabled="true"
                        />
                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.props.input.recv.mbitRate}
                          value2={this.props.output.send.mbitRate}
                          label="Bitrate"
                          type="text"
                          bsClass="form-control"
                          placeholder="Bitrate"
                          placeholder2="Bitrate"
                          disabled="true"
                        />
                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.props.input.link.rtt}
                          value2={this.props.output.link.rtt}
                          label="RTT"
                          type="text"
                          bsClass="form-control"
                          placeholder="RTT"
                          placeholder2="RTT"
                          disabled="true"
                        />

                        <div className="clearfix" />
                      </Form>
                    }
                  />
                </Col>
                <Col
                  md={4}
                  style={{ paddingLeft: 3 + "px", paddingRight: 3 + "px" }}
                >
                  <Card
                    title="SRT Details"
                    content={
                      <Form horizontal style={{paddingTop:10 + "px"}}>
                        <Col md={4}>
                          <Label bsStyle="primary" style={{display: "inline-block", width: 50 + "%"}}></Label>
                        </Col>
                        <Col md={4}>
                          <Label bsStyle="primary direction-label">Receiving</Label>
                        </Col>
                        <Col md={4}>
                          <Label bsStyle="primary direction-label">Sending</Label>
                        </Col>
                        {/* <HorizontalFormInputs
                          ncols={["col-md-12"]}
                          label="Refresh rate"
                          type="text"
                          bsClass="form-control"
                          value="30 seconds"
                          defaultValue=""
                          disabled="true"
                        /> */}

                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.props.input.link.latency}
                          value2={this.props.output.link.latency}
                          label="Latency"
                          type="text"
                          bsClass="form-control"
                          placeholder="Latency"
                          placeholder2="Latency"
                          disabled="true"
                        />
                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.props.selectedContainer ? this.props.selectedContainer.sourceEncryption : ""}
                          value2={this.props.selectedContainer ? this.props.selectedContainer.destEncryption : ""}
                          label="Decryption"
                          type="text"
                          bsClass="form-control"
                          placeholder="Decryption"
                          placeholder2="Decryption"
                          disabled="true"
                        />
                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.props.selectedContainer ? this.props.selectedContainer.sourceTimeout : ""}
                          value2={this.props.selectedContainer ? this.props.selectedContainer.destTimeout : ""}
                          label="Timeout"
                          type="text"
                          bsClass="form-control"
                          placeholder="Timeout"
                          placeholder2="Timeout"
                          disabled="true"
                        />
                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.props.input.recv.bufferMs}
                          label="Buffer size"
                          type="text"
                          bsClass="form-control"
                          placeholder="Buffer size"
                          placeholder2="Buffer size"
                          disabled="true"
                          single="true"
                        />

                        <div className="clearfix" />
                      </Form>
                    }
                  />
                </Col>
                <Col
                  md={4}
                  style={{ paddingLeft: 3 + "px", paddingRight: 3 + "px" }}
                >
                  <Card
                    title="Packet Statistics"
                    content={

                      <Form horizontal style={{paddingTop:10 + "px"}}>
                        <Col md={4}>
                          <Label bsStyle="primary" style={{display: "inline-block", width: 50 + "%"}}></Label>
                        </Col>
                        <Col md={4}>
                          <a href="#" onClick={(e) => {this.showStatsPopup(e, 'input')}} class="btn btn-primary btn-fill btn-link">Receiving</a>
                        </Col>
                        <Col md={4}>
                          <a href="#" onClick={(e) => {this.showStatsPopup(e, 'output')}} class="btn btn-primary btn-fill btn-link">Sending</a>
                        </Col>
                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.props.input.recv.packetsTotal}
                          value2={this.props.output.send.packetsTotal}
                          label="Received/Sent"
                          type="text"
                          bsClass="form-control"
                          placeholder="Packets Received"
                          placeholder2="Packets Sent"
                          disabled="true"
                        />
                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.props.input.recv.packetsLostTotal}
                          value2={this.props.output.send.packetsLostTotal}
                          label="Lost"
                          type="text"
                          bsClass="form-control"
                          placeholder="Packets Received"
                          placeholder2="Packets Sent"
                          disabled="true"
                        />
                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.props.input.recv.packetsDroppedTotal}
                          value2={this.props.output.send.packetsDroppedTotal}
                          label="Dropped"
                          type="text"
                          bsClass="form-control"
                          placeholder="Packets Received"
                          placeholder2="Packets Sent"
                          disabled="true"
                        />
                        <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.props.input.recv.packetsBelated}
                          label="Belated"
                          type="text"
                          bsClass="form-control"
                          placeholder="Packets Received"
                          placeholder2="Packets Sent"
                          disabled="true"
                          single="true"
                        />
                        {/* <HorizontalFormDoubleInputs
                          ncols={["col-md-12"]}
                          onChange={this.onUpdate}
                          value={this.props.recv.packetsUndecrypted}
                          value2={this.props.recv.bytesUndecrypted}
                          label="Undercrypted"
                          type="text"
                          bsClass="form-control"
                          placeholder=" Packets"
                          placeholder2="Bytes"
                          disabled="true"
                        /> */}

                        <div className="clearfix" />
                      </Form>
                    }
                  />
                </Col>
              </Row>
            </Panel.Body>
          </Panel>
        </Grid>
        <Modal
          bsSize="large"
          aria-labelledby='dash-player-modal'
          show={this.state.showInputStats}
          onHide={this.hideStatsPopup}
        >
          <Modal.Header closeButton>
            <Modal.Title id="dash-player-modal">Receiving Statistics</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12}>
                <Chart options={bandwithZoomableOptions} series={this.state.inputStats.bandwith} type="line" height={250} ref={(obj) => {this.graphObjs.bandwidthin = obj;}} />
              </Col>
              <Col md={12}>
                <Chart options={latencyZoomableOptions} series={this.state.inputStats.latency} type="line" height={250} ref={(obj) => {this.graphObjs.latencyin = obj;}} />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.hideStatsPopup}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          bsSize="large"
          aria-labelledby='dash-player-modal'
          show={this.state.showOutputStats}
          onHide={this.hideStatsPopup}
        >
          <Modal.Header closeButton>
            <Modal.Title id="dash-player-modal">Sending Statistics</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12}>
                <Chart options={bandwithZoomableOptions} series={this.state.outputStats.bandwith} type="line" height={250} ref={(obj) => {this.graphObjs.bandwidthout = obj;}} />
              </Col>
              <Col md={12}>
                <Chart options={latencyZoomableSendingOptions} series={this.state.outputStats.latency} type="line" height={250} ref={(obj) => {this.graphObjs.latencyout = obj;}} />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.hideStatsPopup}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}



StreamDetails.propTypes = {
  actions: PropTypes.object.isRequired,
};
function getCurrentStream(state){
  if(state.srtStats.containerId !== undefined)
    return state.streamList.containers.filter( c => c.Id === state.srtStats.containerId);
  else
    return state.streamList.containers[0];
}

function getStatusInput(state) {
  if (state.srtStats.input.link.rtt > 0)
    return 'connected'
  else
    return 'disconnected';
}
function getStatusOutput(state) {
  if (state.srtStats.output.link.rtt > 0)
    return 'connected'
  else
    return 'disconnected';
}
function mapStateToProps(state) {
  //var date1 = new Date();
  //console.log(date1.toString(), '- srtStats:', state.srtStats);
  return {
    input: {
      sid: state.srtStats.input.sid,
      upTime: state.srtStats.input.time,
      peerIP: state.srtStats.input.peerIP,
      recv: state.srtStats.input.recv,
      link: state.srtStats.input.link,
      window: state.srtStats.input.window,
      status: getStatusInput(state)
    },
    output: {
      sid: state.srtStats.output.sid,
      upTime: state.srtStats.output.time,
      peerIP: state.srtStats.output.peerIP,
      send: state.srtStats.output.send,
      link: state.srtStats.output.link,
      window: state.srtStats.output.window,
      status: getStatusOutput(state)
    },
    containerId: state.containerId,
    inputStats: state.streamList.inputStats,
    outputStats: state.streamList.outputStats,
    selectedContainerId: state.streamList.selectedContainerId,
    selectedContainer: getCurrentStream(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StreamDetails);
